import { render, staticRenderFns } from "./user-profile-menu-item.vue?vue&type=template&id=cfcb81ca&scoped=true&"
import script from "./user-profile-menu-item.vue?vue&type=script&lang=ts&"
export * from "./user-profile-menu-item.vue?vue&type=script&lang=ts&"
import style0 from "./user-profile-menu-item.vue?vue&type=style&index=0&id=cfcb81ca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfcb81ca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
